import React from "react";
import { Link } from "react-router-dom";
import "./dashboard.scss";

const stats = [
  { label: "Total products", value: "1,208", meta: "Across 16 categories", icon: "▤" },
  { label: "Visible online", value: "1,164", meta: "96.4% of catalogue", icon: "◉" },
  { label: "Featured products", value: "12", meta: "Shown first on storefront", icon: "★" },
  { label: "Admin users", value: "8", meta: "6 active this month", icon: "♙" },
];

const updates = [
  ["HT Deformed Bar Y10–Y40", "Product details updated", "Admin Lee", "12 min ago"],
  ["Green Wheelie Bin", "Marked as featured", "Mei Ling", "1 hr ago"],
  ["GI Binding Wire Coil", "Visibility changed to hidden", "Admin Lee", "Yesterday"],
  ["Steel", "Category display order updated", "Jason Tan", "2 days ago"],
];

const DashboardPage = () => (
  <div className="dashboard-page">
    <section className="dashboard-page__welcome">
      <div><p>MONDAY, 3 AUGUST 2026</p><h2>Good afternoon, Admin Lee.</h2><span>Here is what is happening with your product catalogue.</span></div>
      <Link to="/admin/products" className="dashboard-page__primary">Manage products <span>→</span></Link>
    </section>
    <section className="dashboard-page__stats">
      {stats.map((item) => <article className="dashboard-page__stat" key={item.label}><div className="dashboard-page__stat-top"><span>{item.icon}</span><small>↗</small></div><p>{item.label}</p><h3>{item.value}</h3><small>{item.meta}</small></article>)}
    </section>
    <section className="dashboard-page__grid">
      <article className="dashboard-page__panel dashboard-page__panel--wide">
        <div className="dashboard-page__panel-head"><div><p>CATALOGUE ACTIVITY</p><h3>Recent updates</h3></div><Link to="/admin/products">View all</Link></div>
        <div className="dashboard-page__updates">
          {updates.map(([name, action, user, time]) => <div className="dashboard-page__update" key={`${name}-${time}`}><span className="dashboard-page__update-icon">□</span><div><strong>{name}</strong><small>{action}</small></div><span>{user}</span><time>{time}</time></div>)}
        </div>
      </article>
      <article className="dashboard-page__panel">
        <div className="dashboard-page__panel-head"><div><p>QUICK ACTIONS</p><h3>Store controls</h3></div></div>
        <Link className="dashboard-page__action" to="/admin/products"><span>＋</span><div><strong>Add a product</strong><small>Create a new storefront listing</small></div><b>›</b></Link>
        <Link className="dashboard-page__action" to="/admin/products"><span>≡</span><div><strong>Arrange products</strong><small>Control featured display order</small></div><b>›</b></Link>
        <Link className="dashboard-page__action" to="/admin/users"><span>♙</span><div><strong>Manage users</strong><small>Administrator accounts</small></div><b>›</b></Link>
      </article>
    </section>
  </div>
);
export default DashboardPage;
